import { render } from "./SaveTemplateModal.vue?vue&type=template&id=4a35850e&scoped=true"
import script from "./SaveTemplateModal.vue?vue&type=script&lang=js"
export * from "./SaveTemplateModal.vue?vue&type=script&lang=js"

import "./SaveTemplateModal.vue?vue&type=style&index=0&id=4a35850e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a35850e"]])

export default __exports__